import React from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import { Grid, MenuItem, TextField } from "@mui/material";
const InsuranceForOthersView = ({
  birthDate,
  handleBirthDateChange,
  classes,
  name,
  setName,
  fathersName,
  setFathersName,
  personalNo,
  setPersonalNo,
  gender,
  setGender,
  surName,
  setSurName,
}) => {
  const genderOptions = [
    { name: "Mashkull", value: "M" },
    { name: "Femër", value: "F" },
  ];
  return (
    <>
      <Grid container item md={12} justifyContent="flex-start">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            label="Datëlindja"
            value={birthDate}
            onChange={handleBirthDateChange}
            views={["day", "month", "year"]}
            inputFormat="dd/MM/yyyy"
            renderInput={(params) => (
              <TextField
                size="small"
                color="warning"
                className={classes.textField}
                {...params}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid container item md={12} justifyContent="flex-start">
        <TextField
          label="Emri"
          size="small"
          color="warning"
          value={name}
          onChange={setName}
          className={classes.textField}
          disabled={birthDate === null}
        />
      </Grid>
      <Grid container item md={12} justifyContent="flex-start">
        <TextField
          label="Mbiemri"
          size="small"
          color="warning"
          value={surName}
          onChange={setSurName}
          className={classes.textField}
          disabled={name === ""}
        />
      </Grid>
      {/* <Grid container item md={12} justifyContent="flex-start">
        <TextField
          placeholder="Emri i prindit"
          size="small"
          color="warning"
          value={fathersName}
          onChange={setFathersName}
          className={classes.textField}
          disabled={surName === ""}
        />
      </Grid> */}
      <Grid container item md={12} justifyContent="flex-start">
        <TextField
          label="Numri Personal"
          size="small"
          color="warning"
          value={personalNo}
          onChange={setPersonalNo}
          className={classes.textField}
          disabled={surName === ""}
        />
      </Grid>
      <Grid container item md={12} justifyContent="flex-start">
        <TextField
          select
          label="Gjinia"
          value={gender}
          onChange={setGender}
          color="warning"
          size="small"
          className={classes.textField}
          disabled={personalNo === ""}
        >
          {genderOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </>
  );
};

export default InsuranceForOthersView;
